import request from '@/utils/request'

// 查询知识产权-事项管理列表
export function listSxgl(query) {
  return request({
    url: '/web/sxgl/list',
    method: 'get',
    params: query
  })
}

// 查询可申报  可预约项
export function getSxglNum(query) {
  return request({
    url: '/web/sxgl/getSxglNum',
    method: 'get',
    params: query
  })
}